// @flow
import { getBuildNumber } from './config';
import { PUBNUB_GLOBAL_NOTIFICATION_RECEIVED } from './actions';
import type { PubnubMessage } from '../../types/pubnub';
import { toast } from 'react-toastify';

/* reducer */
const DEFAULT_STATE = {};

export type State = {
    ...typeof DEFAULT_STATE,
};

export default function reducer(state: State = DEFAULT_STATE, action: any = {}) {
    switch (action.type) {
        case PUBNUB_GLOBAL_NOTIFICATION_RECEIVED:
        default:
            return state;
    }
}

/* SELECTORS */

/* ACTION CREATORS */
export const pubnubGlobalNotificationsOnMessageReceived = (message: PubnubMessage) => async (
    dispatch: Function,
    getState: Function
) => {
    try {
        const { message: msg } = message;

        dispatch({
            payload: msg,
            type: PUBNUB_GLOBAL_NOTIFICATION_RECEIVED,
        });

        if (msg.notificationType === 'textNotification') {
            toast(msg.message, {
                autoClose: false,
            });
        }

        if (msg.notificationType === 'reloadNotification') {
            const state = getState();
            const buildNumber = getBuildNumber(state);

            if (buildNumber !== msg.reloadVersion) {
                if (msg.forceReload === 'no') {
                    toast('Please enjoy the latest version of this page by refreshing your browser.', {
                        autoClose: false,
                    });
                }

                if (msg.forceReload === 'yes') {
                    toast(
                        'This page will automatically refresh in 60 seconds so you can enjoy the latest version of our website.',
                        {
                            autoClose: 60000,
                        }
                    );

                    setTimeout(() => {
                        // eslint-disable-next-line
                        location.reload(true);
                    }, 60000);
                }
            } else {
                console.log(`Reload message received, already on version ${msg.reloadVersion}`);
            }
        }
    } catch (error) {}
};
